import { createSlice } from '@reduxjs/toolkit';

export const communicationSlice = createSlice({
  name: 'communication',
  initialState: {
    comMsg: {
      total: 0,
      inbox: {
        clinic: 0,
        patient: 0,
      },
    },
  },
  reducers: {
    // Update the total message count
    setMessageCount: (state, action) => {
      state.comMsg.total = action.payload;
    },

    // Update the inbox message count
    setMsgInboxCount: (state, action) => {
      state.comMsg.inbox = { ...state.comMsg.inbox, ...action.payload };
    },
  },
});

export const { setMessageCount, setMsgInboxCount } = communicationSlice.actions;
export default communicationSlice.reducer;
